<template lang="jade">
  #app(flex="dir:top")
    router-view(:user="user")
</template>

<script>
import Referral from './api/referral.api.js'

export default {
  name: 'app',
  data () {
    return {
      user: {
        contractStartTime: '',
        contractEndTime: '',
        username: '',
        email: '',
        status: ''
      }
    }
  },
  mounted () {
    // debug purpose only, DO NOT USE
    window.$app = this
    // 进入referral-partner填写表单页面
    if (this.$route.path === '/information') return
    // 进入referral-partner的protocol页面
    if (this.$route.path === '/protocol') return
    // 非登录页面且没有用户信息则跳到登录页面
    if (!Referral.isLogined()) {
      this.$router.push({ path: 'login' })
      return
    }

    this.getUserInfo()
  },
  methods: {
    isUserInfoEmpty () {
      if (!this.user) return true
      const u = this.user
      return !u.username &&
        !u.email &&
        !u.status &&
        !u.contractStartTime &&
        !u.contractEndTime
    },
    setUserInfo (user) {
      this.user = user
    },
    getUserInfo () {
      return Referral.getUserInfo().then(e => {
        if (e.data.success) {
          this.user = e.data.data
        } else {
          this.$router.push({ path: 'referral' })
        }
      }).catch(_ => _)
    }
  }
}
</script>

<style lang="stylus">
  html,body
    height 100%
  #app
    min-height 100%
</style>



// WEBPACK FOOTER //
// App.vue?3bbc36f4